import React, { Component } from 'react'
import { Elements } from 'react-stripe-elements'
import CardForm from './CardForm'
import './Checkout.scss'
const windowGlobal = typeof window !== 'undefined' && window

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elementFontSize: windowGlobal ? windowGlobal.innerWidth < 450 ? '14px' : '18px' : '18px'
    }
    windowGlobal && windowGlobal.addEventListener('resize', () => {
      if (windowGlobal.innerWidth < 450 && this.state.elementFontSize !== '14px') {
        this.setState({elementFontSize: '14px'});
      } else if (
        windowGlobal.innerWidth >= 450 &&
        this.state.elementFontSize !== '18px'
      ) {
        this.setState({elementFontSize: '16px'});
      }
    });
  }

  render() {
    const { elementFontSize } = this.state;
    const { loading, error, vouchers } = this.props;

    return (
      <div className="form-container">
        <Elements>
          <CardForm fontSize={elementFontSize} error={error} loading={loading} vouchers={vouchers} />
        </Elements>
      </div>
    )
  }
}

export default Checkout


// WEBPACK FOOTER //
// ./src/components/Checkout.js